import { render, staticRenderFns } from "./qwxzs.vue?vue&type=template&id=00047735&scoped=true&"
import script from "./qwxzs.vue?vue&type=script&lang=js&"
export * from "./qwxzs.vue?vue&type=script&lang=js&"
import style0 from "./qwxzs.vue?vue&type=style&index=0&id=00047735&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00047735",
  null
  
)

export default component.exports